import type { Viewport } from 'pixi-viewport';
import type { Rectangle } from 'pixi.js';

export const fitRectangleToViewport =
  (viewport: Viewport, margin = 0) =>
  (rectangle: Rectangle): void => {
    const scale = Math.min(
      (viewport.screenWidth - 2 * margin) / rectangle.width,
      (viewport.screenHeight - 2 * margin) / rectangle.height,
    );
    viewport
      .setZoom(scale)
      .moveCenter(
        rectangle.x + rectangle.width / 2,
        rectangle.y + rectangle.height / 2,
      );
  };
